import React from 'react'
import SpecialInstruction from '../../../../components/elements/SpecialInstruction'

/**
 * Bottom-of-modal summary of side effects the Save button will trigger.
 *
 * Behaviour-preserving extraction from DmcModal.jsx. Parent passes everything
 * as props; no internal state.
 */
export default function DmcActionSummary({ isCreating, isActive, showConfirmedWarning }) {
  if (!isCreating && !isActive) {
    return (
      <div className="column" data-testid="dmc-action-summary-danger">
        <SpecialInstruction
          content={'<span>' +
            '<span class="has-text-weight-bold">This will perform the following actions:</span>' + '<br>' +
            '<span class=\'pl-2\'>• Update record in loan_dmcs for customer_id</span> <br> ' +
            (showConfirmedWarning ? '<span class=\'pl-2\'>• Change the loan_status to Collections</span> <br> ' : '') +
            '<span class=\'pl-2\'>• Set loan_dmcs record to inactive (not in force)</span> <br> ' +
            '<span class=\'pl-2\'>• Set power_of_attorney_customers record (if applicable) to inactive (not in force)</span> <br> ' +
            '<span class=\'pl-2\'>• Set cease_and_desists record (if applicable) to inactive (not in force)</span> <br> ' +
            '<span class=\'pl-2\'>• Customer\'s contact details will be used for outreach again</span> <br> ' +
            ' </span>'}
          type="is-danger"
        />
      </div>
    )
  }

  return (
    <div className="column" data-testid="dmc-action-summary-warning">
      <SpecialInstruction
        content={'<span>' +
          '<span class="has-text-weight-bold">This will perform the following actions:</span>' + '<br>' +
          '<span class=\'pl-2\'>• Create record in loan_dmcs for customer_id</span> <br> ' +
          (showConfirmedWarning ? '<span class=\'pl-2\'>• Change the loan_status to Collections</span> <br> ' : '') +
          '<span class=\'pl-2\'>• Any contact/bank info provided will replace the customer\'s for the duration of this loan</span> <br> ' +
          '<span class=\'pl-2\'>• This will remove any outstanding emails created but not yet sent that are Transactional or Marketing messages</span> <br> ' +
          '<span class=\'pl-2\'>• IF PoA document uploaded, will create a power_of_attorney_customers record for this loan ONLY</span> <br> ' +
          ' </span>'}
        type="is-warning"
      />
    </div>
  )
}
